module.exports = __webpack_public_path__ + "static/fonts/ibm-plex-mono-v12-latin-300.74b3f0e.woff2";